export const getRouteLinkIndexAdmin = () => {
  const navItem = [
    {
      title: "Dashboard",
      link: "/dashboard",
    },
    {
      title: "Admins",
      link: "/admins",
    },
    {
      title: "Queries",
      link: "/queries",
    },
    {
      title: "My Profile",
      link: "/myprofile",
    },
  ];
  if (typeof window === "undefined") return null; // Handle SSR

  const currentPath = window.location.pathname;
  const currentItem = navItem.find((item) => item.link === currentPath);

  return currentItem || null;
};
